import axios, {parseResponseData} from '@/axiosInstance'
import {Access} from '@/features/accesses/types'
import {EventSmall} from '@/features/agenda/types'
import {MedicalReportType} from '@/types'
import {captureException} from '@sentry/react'
import {z} from 'zod'

export const HomePageDataResponse = z.object({
    reports: z
        .object({
            missed: z.array(Access),
            draft: z.array(
                z.object({
                    createdAt: z.string(),
                    id: z.string(),
                    medicalRecordReportType: MedicalReportType,
                    project: z.object({
                        id: z.string(),
                        patientId: z.string()
                    })
                })
            )
        })
        .optional(),
    events: z.array(EventSmall).optional(),
    projects: z
        .object({
            total: z.number(),
            suspended: z.number(),
            expiring: z.number()
        })
        .optional()
})

export type HomePageDataResponse = z.infer<typeof HomePageDataResponse>

export interface HttpGetHomePageDataOptions {
    params: {
        fields: ('reports' | 'events' | 'projects')[]
        // Optional date range (YYYY-MM-DD) applied by the backend to the `reports` section
        startDate?: string
        endDate?: string
    }
}

export const httpGetHomePageData = async ({params}: HttpGetHomePageDataOptions) => {
    const response = await axios.get('dashboard/homepage', {params})
    return parseResponseData({
        responseData: response.data,
        responseShape: HomePageDataResponse,
        onZodError: captureException
    })
}
